import React, { useId } from 'react';
import { Check } from 'lucide-react';
import type { CheckboxProps } from './checkbox.types';
import { useCheckboxStyles } from './checkbox.hooks';
import styles from './checkbox.module.css';

const Checkbox: React.FC<CheckboxProps> = ({
    checked,
    defaultChecked,
    disabled = false,
    label,
    onCheckedChange,
    onChange,
    size = 'medium',
    mode = 'normal',
    className,
    id: providedId,
    ...props
}) => {
    const generatedId = useId();
    const id = providedId || generatedId;

    const { containerClassName, wrapperClassName, inputClassName, labelClassName } = useCheckboxStyles({
        className,
        size,
        mode,
        disabled,
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (disabled) return;
        onChange?.(e);
        onCheckedChange?.(e.target.checked);
    };

    return (
        <div className={containerClassName}>
            <div className={wrapperClassName}>
                <input
                    type="checkbox"
                    id={id}
                    checked={checked}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                    onChange={handleChange}
                    className={inputClassName}
                    {...props}
                />
                <span className={styles.checkIcon} aria-hidden>
                    <Check />
                </span>
            </div>
            {label && (
                <label htmlFor={id} className={labelClassName}>
                    {label}
                </label>
            )}
        </div>
    );
};

export default Checkbox;
